import React from 'react';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { Vector } from 'prelude-ts';

import { RuleExecutor } from '../Rule';
import Formula from './Formula';
import Statement from '../Statement';

import styles from '../styles/Formula.module.css';

/**
 * The unit for a `Connective`.
 */
abstract class Unit extends Formula {
  subFormulae(): Vector<Formula> {
    return Vector.empty();
  }

  protected abstract getSymbol(): string;

  toTex(): string {
    return this.getSymbol();
  }

  protected abstract onClick(
    subgoal: Statement,
    executor: RuleExecutor
  ): (() => void) | undefined;

  render(subgoal: Statement, executor: RuleExecutor): JSX.Element {
    const onClick = this.onClick(subgoal, executor);
    const enabled = onClick !== undefined;

    return (
      <div
        className={classNames(styles.formula, styles.unit, {
          [styles.active]: enabled
        })}
        onClick={onClick}
      >
        <div className={classNames(styles.text)}>
          <Typography align="center" inline>
            {this.getSymbol()}
          </Typography>
        </div>
      </div>
    );
  }
}

export default Unit;
